import { render, staticRenderFns } from "./WhiteListEdit.vue?vue&type=template&id=8cbb6406&scoped=true"
import script from "./WhiteListEdit.vue?vue&type=script&lang=js"
export * from "./WhiteListEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cbb6406",
  null
  
)

export default component.exports